import PropTypes from 'prop-types'
import React from 'react'

import ValidationInfo from './ValidationInfo'
import ValidationText from './ValidationText'
import FormGroup from './FormGroup'

const TextArea = ({
  name,
  note,
  label,
  value,
  onChange,
  size = 8,
  className = '',
  info,
  helpText,
  maxLength,
  required,
  isValid,
  disabled,
  readOnly
}) => {

  const textarea = (
    <textarea
      className="form-control"
      id={name}
      name={name}
      value={value}
      maxLength={maxLength}
      required={required}
      disabled={disabled}
      readOnly={readOnly}
    />
  )

  return (
    <FormGroup
      label={label}
      name={name}
      info={info}
      note={note}
      onChange={onChange}
    >
      <div className={`col-xs-${size} ${className}`}>
        {textarea}

        {
          helpText
            ? <div className="help-block">{helpText}</div>
            : null
        }
        <ValidationText isValid={isValid}>
          <ValidationInfo isValid={isValid} />
        </ValidationText>
      </div>
    </FormGroup>
  )

}

TextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  group: PropTypes.string,
  helpText: PropTypes.string,
  info: PropTypes.string,
  isValid: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      errors: PropTypes.object,
      valid: PropTypes.bool
    })
  ]),
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  note: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  size: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])
}

export { TextArea as default }



// WEBPACK FOOTER //
// ./src/shared/components/TextArea.js